import * as React from "react";
import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import "../../style/common/style.scss";
import { InputAdornment } from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import moment from "moment/moment";
export default function CustomDatePickerV2(props) {
  const [value, setValue] = React.useState(null);
  const {
    label,
    selectedDate,
    onChange,
    maxDate = "",
    minDate = moment(new Date()).format("YYYY-MM-DD"),
    disabled = false,
    onKeyDown,
    id,
  } = props;
  const [isOpen, setIsOpen] = React.useState(false);
  React.useEffect(() => {
    if (selectedDate) setValue(selectedDate);
    else setValue(null);
  }, [selectedDate]);
  const handleOnChange = (newValue) => {
    setValue(newValue);
    onChange(newValue);
  };
  const handleKeyDown = (e) => {
    // Check if the key pressed is the spacebar (keyCode 32)
    if (e.keyCode === 32) {
      !disabled && setIsOpen(true); // Open date picker on spacebar press
    } else {
      // If not spacebar, trigger the provided onKeyDown event handler
      onKeyDown && onKeyDown(e);
    }
  };
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        views={['month', 'year']}
        label={label}
        value={value}
        inputFormat="MMM-YY"
        className="datePicker"
        onChange={handleOnChange}
        maxDate={maxDate}
        minDate={minDate}
        open={isOpen}
        disabled={disabled}
        onClose={() => setIsOpen(false)}
        renderInput={(params) => (
          <TextField
            {...params}
            inputProps={{ ...params.inputProps, readOnly: true }}
            sx={{
              width: "100%",
              "& label.Mui-focused": {
                color: "#004F9E !important", // change this to the desired color
              },
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: isOpen ? "#004F9E" : "#a6a8ab",
                },
                "&:hover fieldset": {
                  borderColor: isOpen ? "#004F9E" : "#a6a8ab",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#004F9E",
                },
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <CalendarTodayIcon />
                </InputAdornment>
              ),
            }}
            onClick={() => !disabled && setIsOpen(true)}
            InputLabelProps={{
              style: { color: isOpen ? "#004F9E" : "#666666" },
            }}
            onKeyDown={(e)=>{
                handleKeyDown(e)
                setIsOpen(false)
              }}
            // onKeyDown={handleKeyDown}
            id={id}
          />
        )}
      />
    </LocalizationProvider>
  );
}